import React from 'react';
import classnames from 'classnames';
import MapPoints from 'components/MapPoints';
import useIntersection from 'hooks/useIntersection';
import * as styles from './research.module.scss';

const Research = ({ data }) => {
  const { scrollWrapper, inViewSec, inViewRefSec } = useIntersection({
    threshold: 0.4,
  });

  return (
    <section className={classnames(styles.section)} ref={scrollWrapper}>
      <div className="cr-wrap">
        <div
          className={classnames(styles.inner, inViewSec && styles.jsAnimInit)}
          ref={inViewRefSec}
        >
          <div className={classnames(styles.content)}>
            <p
              className={classnames(
                styles.subtitle,
                'cr-subheader cr-subtitle-sec cr-text-3 '
              )}
            >
              {data.subtitle && data.subtitle}
            </p>

            <h2
              className={classnames(
                styles.title,
                'cr-h2 cr-underline-gradient'
              )}
            >
              {data.title && data.title}
            </h2>

            <p className={classnames(styles.description, 'cr-lead')}>
              {data.description && data.description}
            </p>
          </div>

          <div className={classnames(styles.mediaWrap)}>
            <div className={classnames(styles.media)}>
              <i className={classnames(styles.animContainer)}>
                <MapPoints />
              </i>
            </div>

            <div className={classnames(styles.pointA)}>
              <h4 className={classnames(styles.pointTitle, 'cr-h4')}>
                {data.point_a.title && data.point_a.title}
              </h4>

              <ul className={classnames(styles.pointList)}>
                {data.point_a.list.length &&
                  data.point_a.list.map((item) => {
                    return <li key={item}>{item}</li>;
                  })}
              </ul>
            </div>

            <div className={classnames(styles.pointB)}>
              <h4 className={classnames(styles.pointTitle, 'cr-h4')}>
                {data.point_b.title && data.point_b.title}
              </h4>

              <ul className={classnames(styles.pointList)}>
                {data.point_b.list.length &&
                  data.point_b.list.map((item) => {
                    return <li key={item}>{item}</li>;
                  })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Research;
